import styled, { css } from 'styled-components';
import { getMenuLinkTheme, MenuItemLabelContainer, } from '../../../navigation/menu-item/styles';
import { getAppTheme } from '../../../navigation/styles';
const getUserMenuButtonAppStyling = (theme) => {
    const appTheme = getAppTheme(theme);
    return css `
    color: ${appTheme.headerTextColor};
    &:hover {
      background-color: ${appTheme.headerItemHoverColor};
    }
  `;
};
export const UserMenuButtonStyled = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;

  width: 100%;
  max-width: 350px;
  cursor: pointer;
  padding-inline: 8px;
  padding-block: 4px;
  gap: 4px;
  border-radius: 4px;
  ${({ theme }) => getUserMenuButtonAppStyling(theme)}
  ${({ $sidebar, $compact, theme }) => $sidebar &&
    css `
      border: 0;
      background: ${theme.colors.transparent};
      font: inherit;
      text-align: left;
      min-width: 0;
      min-height: ${theme.spacing.xxl}px;
      padding: ${theme.spacing.sm}px;
      border-radius: ${theme.border_radius.md};
      justify-content: ${$compact ? 'center' : 'flex-start'};
      color: ${getAppTheme(theme).textColor};
      & > * {
        min-width: 0;
      }
      & > :first-child,
      & > svg {
        flex-shrink: 0;
      }
      &:hover {
        background: ${theme.colors.grey_5};
      }
      &:focus-visible {
        outline: 2px solid ${theme.colors.primary};
        outline-offset: 2px;
      }
    `}
`;
const getMenuItemColorsStyling = (theme, isCurrent, disabled, noStyle) => {
    const navTheme = getMenuLinkTheme(theme, 'client', isCurrent);
    return css `
    cursor: pointer;
    color: ${disabled ? navTheme.disabledColor : navTheme.color};

    ${!noStyle &&
        `
  &:hover {
    background-color: ${navTheme.hoverBackground};
    color: ${disabled ? navTheme.disabledHoverColor : navTheme.hoverColor};
  }`}
  `;
};
export const UserMenuDropdownStyled = styled.div `
  background-color: ${({ theme }) => theme.colors.white_1};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow_hover};
  min-width: 220px;
  .ant-dropdown-menu {
    padding: 0;
    .ant-dropdown-menu-item {
      padding: 0;
    }
  }
  ul,
  li {
    display: block;
  }
  ${MenuItemLabelContainer} {
    width: 100%;
    padding-inline: ${({ theme }) => theme.spacing.md}px;
    padding-block: ${({ theme }) => theme.spacing.sm}px;
    gap: ${({ theme }) => theme.spacing.sm}px;
    cursor: pointer;
    margin: 0;
    ${({ theme }) => getMenuItemColorsStyling(theme, false)}
  }
`;
export const MobileUserMenuPanel = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 26px;
`;
